import { render } from "./HeadMenu.vue?vue&type=template&id=4fa9eb16"
import script from "./HeadMenu.vue?vue&type=script&lang=js"
export * from "./HeadMenu.vue?vue&type=script&lang=js"

import "./HeadMenu.vue?vue&type=style&index=0&id=4fa9eb16&lang=css"

import exportComponent from "/Users/shan/www/xnz_merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__